import { CookieSetOptions } from "universal-cookie"

export const IFRAME_ORIGIN = import.meta.env.VITE_AXLE_IFRAME_URL

export const AXLE_DEFAULT_ENTRY_URL = `${IFRAME_ORIGIN}/auth/token`

export const AXLE_COMPONENT_TOKEN_COOKIE_NAME = "axle-component-token"
export const SMART_CHARGING_COMPONENT_TOKEN_COOKIE_NAME =
  "smart-charging-component-token"
export const AXLE_COMPONENT_TOKEN_COOKIE_OPTIONS: CookieSetOptions = {
  path: "/",
  maxAge: 60 * 50, // 50 minutes
  secure: true,
}
